import { render, staticRenderFns } from "./AddNewSupport.vue?vue&type=template&id=b614e83a&scoped=true"
import script from "./AddNewSupport.vue?vue&type=script&lang=js"
export * from "./AddNewSupport.vue?vue&type=script&lang=js"
import style0 from "./AddNewSupport.vue?vue&type=style&index=0&id=b614e83a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b614e83a",
  null
  
)

export default component.exports